import gql from 'graphql-tag';

export const getContentQuery = gql`
  query Content($name: String!) {
    allygnContent(name: $name) {
      text
    }
  }
`;
